import Box from '@mui/material/Box';
import { useTheme, Typography, alpha, Stack } from '@mui/material';
import Logo from '@common/assets/svgs/Logo';

const LoadingScreen = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        minWidth: '100vw',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.03)} 0%, ${alpha(
          theme.palette.secondary.main,
          0.03
        )} 100%)`,
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '50%',
          background: `linear-gradient(180deg, ${alpha(
            theme.palette.primary.main,
            0.05
          )} 0%, transparent 100%)`,
          zIndex: 0,
        },
      }}
    >
      <Stack alignItems="center" spacing={3} sx={{ position: 'relative', zIndex: 1 }}>
        <Logo
          sx={{
            animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
            '@keyframes pulse': {
              '0%, 100%': {
                opacity: 1,
              },
              '50%': {
                opacity: 0.5,
              },
            },
          }}
        />

        <Typography
          variant="body1"
          sx={{
            color: 'text.secondary',
            fontWeight: 500,
            animation: 'fadeInOut 2s ease-in-out infinite',
            '@keyframes fadeInOut': {
              '0%, 100%': { opacity: 0.5 },
              '50%': { opacity: 1 },
            },
          }}
        >
          Chargement...
        </Typography>
      </Stack>
    </Box>
  );
};

export default LoadingScreen;
